import React, {memo, useEffect} from 'react'
import {withErrorHandling, withTaskData} from '../../hoc'
import {Button, Header, Table} from 'semantic-ui-react'
import {useSafeState} from '../../hook'

const isPendingTask = (pendingTasks) => {
  return pendingTasks.some(pt => ['MERGE_CONTRACT', 'COPY_FORWARD_LAST_VERSION', 'UPDATE_CONTRACT_INFO', 'SYNC_VERSION_WITH_CONTRACT'].includes(pt.type))
}

const getDescription = (count) => {
  const message = count === 1 ? 'is 1 update' : `are ${count} updates`
  return `There ${message} still pending for this service version. Please wait a few seconds and check again.`
}

const _PendingTasks = (
  {
    pendingTasks = [],
    mutateTasks,
    children
  }
) => {
  const [state, setState] = useSafeState({checking: false})

  useEffect(() => {
    setState({checking: false})
  }, [])

  const onCheckAgain = (e) => {
    e.preventDefault()
    setState({checking: true})
    setTimeout(() => {
      setState({checking: false})
    }, 2000)
    mutateTasks()
  }

  if (!isPendingTask(pendingTasks)) {
    return children
  }

  return (
    <>
      <Header as='h4'>Pending Tasks</Header>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Task</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              {
                getDescription(pendingTasks.length)
              }
            </Table.Cell>
          </Table.Row>
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan='1'>
              <Button onClick={onCheckAgain} loading={state.checking}>Check Again</Button>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  )
}

let PendingTasks = (props) => {
  return <_PendingTasks {...props}/>
}

PendingTasks = withTaskData(PendingTasks, 'Loading tasks...', 5000)
PendingTasks = withErrorHandling(PendingTasks)
PendingTasks = memo(PendingTasks)

export {_PendingTasks, PendingTasks}

export default PendingTasks